//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.TrimCurveBoundingObjectBuilderList.js";
import "../GeometricUtilities/GeometricUtilities.CurveOptions.js";
import "../no/Section.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[1,"BoundingObjectList",0,"GeometricUtilities.TrimCurveBoundingObjectBuilderList",0],[0,"CurveExtensionOption",1,0],[1,"CurveOptions",0,"GeometricUtilities.CurveOptions",0],[1,"CurveToTrim",0,"Section",0],[0,"DirectionOption",1,0],[0,"KeepOrDiscard",1,0],[0,"MakeInputCurvesDashed",1,0],[0,"OperationOption",1,0],[0,"PerformExtendedIntersectionCalculation",1,0],[0,"ProcessBoundingObjects",1,0],[0,"Vector",1,"Direction",0]],[[["help_point"],"SelectTrimRegion",{},1,0],[["help_point"],"DeselectTrimRegion",{},1,0],[[],"ResetTrimRegions",{},0,0],[["helpPoint"],"SelectDivideLocation",{},1,0],[["helpPoint"],"DeselectDivideLocation",{},1,0],[[],"UpdateTrimRegionsAndDivideLocations",{},0,0],[[],"CreateTrimCurveBoundingObjectBuilder",{R_:{boundingObjBuilder:"GeometricUtilities.TrimCurveBoundingObjectBuilder"}},0,0]],[]];
SPLM.Features.TrimCurve2Builder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TrimCurve2Builder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TrimCurve2Builder.Operation = Object.freeze({
    "Trim" : "Trim", "Divide" : "Divide"});

SPLM.Features.TrimCurve2Builder.Direction = Object.freeze({
    "Shortest3DDistance" : "Shortest3DDistance", "AlongDirection" : "AlongDirection"});

SPLM.Features.TrimCurve2Builder.KeepDiscard = Object.freeze({
    "Keep" : "Keep", "Discard" : "Discard"});

SPLM.Features.TrimCurve2Builder.CurveExtension = Object.freeze({
    "Natural" : "Natural", "Linear" : "Linear", "Circular" : "Circular", "None" : "None"});

export default SPLM;